export function omitEmptyQuery<Query extends Record<string, unknown>>(query?: Query): Query | undefined {
  if (!query) return undefined;

  const next: Record<string, unknown> = {};
  Object.entries(query).forEach(([key, value]) => {
    if (value === undefined || value === null) return;
    if (value === "") return;
    next[key] = value;
  });

  return Object.keys(next).length ? (next as Query) : undefined;
}
